import React from "react";
import OrderTableServerFiltering from "../components/OrderTableServerFiltering";
import { useSearchParams } from "react-router-dom";
import Layout from "../components/Layout";


const OrdersPage: React.FC = () => {
    const [searchParams] = useSearchParams();
    const customerId = searchParams.get("customerId") ? searchParams.get("customerId") : null;

    return (
        <Layout>
            <OrderTableServerFiltering customerId={customerId} />
        </Layout>
    );
};

export default OrdersPage;
